import { CollectionListScreen } from 'app/features/collection/list'
import { GetServerSideProps } from 'next'
import { makeQuery as makeSingleQuery } from 'app/hooks/use-query'
import { dehydrate, QueryClient } from 'react-query'
import { collectionListPrefetcher } from '../../lib/collection-list-prefetcher'
import {
  createAllSeriesPageQuery,
  mapToAllSeriesPageContent,
} from 'app/queries/globals/all-series-page'
import { UserStore } from 'app/store/user-store'
import { withAuthedPage } from 'lib/session'
import { verifyUser } from 'lib/verify-user'

export default function ContentListPage() {
  return <CollectionListScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const store = context.req?.userStore
    const redirect = verifyUser(store)
    if (redirect) return redirect

    const queryClient = new QueryClient()
    const allSeriesPageQuery = createAllSeriesPageQuery()

    await Promise.all([
      collectionListPrefetcher(queryClient, { excludeHidden: true }),
      queryClient.fetchQuery(['query', allSeriesPageQuery, {}], async () => {
        return makeSingleQuery(
          allSeriesPageQuery,
          {},
          mapToAllSeriesPageContent,
          store,
        )
      }),
    ])

    const dehydratedState = dehydrate(queryClient)

    return {
      props: {
        dehydratedState,
      },
    }
  },
)
